import clsx from "clsx";
import React from "react";

import Button, { ButtonStyle } from "components/Button";
import Modal from "components/Modal";
import { DEFAULT_MODAL_BODY_ID, DEFAULT_MODAL_TITLE_ID } from "constants/modalTemplate";
import { ModalStore } from "store/modalStore";

type DynamicHeightConfirmModalProps = {
  data: ModalStore;
  closeModal: () => void;
  modalTitleId?: string;
  modalBodyId?: string;
};

/**
 * DynamicHeightConfirmModal: confirm modal with dynamic height (sub message is dynamic height)
 * min height is 250px
 * 
 * @param data - modal data (confirm message, sub message, positive button text, positive action, cancel action, top)
 * @param closeModal - close modal function
 * @param modalTitleId - modal title id
 * @param modalBodyId - modal body id
 */
export const DynamicHeightConfirmModal = ({
  data,
  closeModal,
  modalTitleId = DEFAULT_MODAL_TITLE_ID,
  modalBodyId = DEFAULT_MODAL_BODY_ID,
}: DynamicHeightConfirmModalProps) => {
  if (!data.dynamicHeightConfirm) return null;

  return (
    <Modal
      onClose={() => {
        data.dynamicHeightConfirm?.cancelAction && data.dynamicHeightConfirm.cancelAction();
        closeModal();
      }}
      isOpen={data.dynamicHeightConfirm.modalState === "open"}
    >
      <div className="flex min-h-[250px] w-[400px] flex-col items-center px-8 pb-5">
        
        {/* text area */}
        <div className={clsx(
          "flex flex-col items-center w-full",
          data.dynamicHeightConfirm.top ? data.dynamicHeightConfirm.top : "mt-16"
        )}>
          <div className="flex items-center justify-center">
            <p className="ml-2 text-19 font-bold text-center" id={modalTitleId}>
              {data.dynamicHeightConfirm.confirmMessage}
            </p>
          </div>
          <p className="mt-4 text-16px text-center break-words w-full" id={modalBodyId}>
            {data.dynamicHeightConfirm.subMessage}
          </p>
        </div>

        {/* button area */}
        <div className="mt-auto flex justify-center gap-4 py-5 w-full">
          <div className="w-[160px]">
            <Button
              text={"キャンセル"}
              onClick={() => {
                data.dynamicHeightConfirm?.cancelAction && data.dynamicHeightConfirm.cancelAction();
                closeModal();
              }}
              style={ButtonStyle.OUTLINE}
            />
          </div>
          <div className="w-[160px]">
            <Button
              text={data.dynamicHeightConfirm.positiveButtonText}
              onClick={data.dynamicHeightConfirm.positiveAction}
              style={ButtonStyle.PRIMARY}
            />
          </div>
        </div>
      </div>
    </Modal>
  );
};
